import React from 'react';
import styled, { CSSProperties } from 'styled-components';
import Icon from '../Icons/Icon';
import { IinventoryItem } from '@typings/store/storeItem.interface';
import Tooltip from '@components/dataDisplay/Tooltip';

const Img = styled.div`
  width: 52px;
  height: 52px;
  background: var(--backgroundColor);
  border-radius: 8px;
  font-size: 12px;
  border: 1px solid var(--lineColor);
  display: flex;
  justify-content: center;
  align-items: center;
  object-fit: contain;
  position: relative;
  &:hover {
    border: 1px solid var(--primaryColor);
  }
  /* overflow는 툴팁을 가리지 않도록 제거, 내부 이미지 클리핑은 하위에서 처리 */
`;

const ImgClip = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    display: block;
  }
`;

const CountBedge = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  border-radius: 4px;
  width: 16px;
  height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--buttonBackgroundColor);
  color: var(--buttonTextColor);
`;

const PresentBedge = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  border-radius: 4px;
  top: 0;
  right: 0;
  width: 16px;
  height: 16px;
  background-color: var(--primaryColor);
`;

const ReinforceSec = styled.div`
  position: absolute;
  right: 4px;
  bottom: 0;
  display: flex;
  gap: 2px;
  color: white;
  font-weight: 700;
  text-shadow: 0px 0px 6px black;
`;

type Props = {
  data: IinventoryItem | any;
  onClick?: () => void;
  style?: CSSProperties;
  showTitle?: boolean;
  className?: string;
  showTooltip?: boolean;
  hideReinforce?: boolean;
};
function ItemImgCard({ data, onClick, style, showTitle, className, showTooltip = false, hideReinforce = false }: Props) {
  if (!data) return null;

  const tooltipText =
    data.title || data.customTitle || data.name || data.description || '아이템';

  return (
    <Tooltip message={tooltipText} hidden={!showTooltip}>
      <Img
        className={className}
        onClick={onClick}
        style={{
          border:
            data.reinforceCount && data.reinforceCount === 5
              ? '1px solid var(--primaryColor)'
              : '1px solid var(--lineColor)',
          ...style,
        }}
      >
        <ImgClip>
          {data.imgURL ? (
            <img src={data.imgURL} alt={data.title || '아이템 이미지'} />
          ) : (
            <div style={{ color: 'var(--subTextColor)' }}>없음</div>
          )}
        </ImgClip>

        {data.multiple && data.multiple.length > 1 && (
          <CountBedge>{data.multiple.length}</CountBedge>
        )}
        {(data.isPresent || data.giftingCharID) && (
          <PresentBedge>
            <Icon name="Present14" color="var(--subColor)" />
          </PresentBedge>
        )}

        {showTitle && <div>{tooltipText}</div>}

        {!hideReinforce && data.reinforceCount != null && (
          <ReinforceSec>{`+${data.reinforceCount}`}</ReinforceSec>
        )}
      </Img>
    </Tooltip>
  );
}

export default React.memo(ItemImgCard);
